module.exports = __webpack_public_path__ + "img/benefit3.f05f7072.jpg";